import { FC, useEffect, useMemo, useState } from "react";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Heading2 from "components/Heading/Heading2";
import CarCardH from "components/CarCardH/CarCardH";
import { getCenter, getDistance } from "geolib";
import MapContainer from "containers/MapContainer";
import { useFilterStore } from "../../stores/Filter.store";
import { useServices } from "../../hooks/collections/useServices";
import { useServicesStore } from "../../stores/Services.store";
import { useLoader } from "../../@shared/hooks/useLoader";
import { IService } from "../../@core/interfaces/IService";
import { useGeolocation } from "react-use";
import { orderBy } from "lodash";
import TabFilters from "./TabFilters";

export interface SectionGridHasMapProps {
}

const SectionGridHasMap: FC<SectionGridHasMapProps> = () => {
  const { latitude, longitude } = useGeolocation();
  const { services, populatedServices } = useServices(true);
  const [currentHoverID, setCurrentHoverID] = useState<string | number>(-1);
  const [showFullMapFixed, setShowFullMapFixed] = useState(false);
  const filters = useFilterStore((state => state.filters));
  const setServicesPopulated = useServicesStore((state => state.setServices));
  const servicesPopulated = useServicesStore((state => state.services));
  const loader = useLoader()
  const [initialCenterSaved, setInitialCenterSaved] = useState(null);

  const displayData = useMemo(() => {
    if (latitude && longitude && servicesPopulated.length >= 1) {
      const dataWithDistances = servicesPopulated.map((item: IService) => ({
        ...item,
        distance: getDistance(
          { latitude, longitude },
          {
            latitude: item.details.location.coordinates.lat,
            longitude: item.details.location.coordinates.lng
          }
        )
      }));

      if (!initialCenterSaved) {
        const center = getCenter(servicesPopulated.map((item: IService) => ({
          latitude: item.details.location.coordinates.lat,
          longitude: item.details.location.coordinates.lng
        })));

        if (center) setInitialCenterSaved(center)
      }

      if (filters.distanceRange && Array.isArray(filters.distanceRange) && filters.distanceRange.length === 2) {
        const [minDistance, maxDistance] = filters.distanceRange;
        return dataWithDistances.filter(item =>
          item.distance >= minDistance && item.distance <= maxDistance
        );
      }

      return dataWithDistances;
    }
    return orderBy(servicesPopulated, ["distance"], ["desc"]);
  }, [filters, servicesPopulated, latitude, longitude]);

  useEffect(() => {
    async function fetchAndPopulateServices() {
      loader.start();
      setServicesPopulated(await populatedServices(services));
      loader.stop();
    }

    fetchAndPopulateServices();
  }, [services]);

  return (
    <div>
      <div className="relative flex min-h-screen">
        {/* CARDSSSS */}
        <div className="min-h-screen w-full xl:w-[780px] 2xl:w-[880px] flex-shrink-0 xl:px-8 ">
          <Heading2
            heading="Car wash services in the US"
            subHeading={
              <span className="block text-neutral-500 dark:text-neutral-400 mt-3">
                {displayData.length} cars
              </span>
            }
          />
          <div className="mb-8 lg:mb-11">
            <TabFilters/>
          </div>
          <div className="grid grid-cols-1 gap-8">
            {displayData.length ? displayData.map((item: IService) => (
              <div
                key={item.id}
                onMouseEnter={() => setCurrentHoverID((_) => item.id)}
                onMouseLeave={() => setCurrentHoverID((_) => -1)}
              >
                <CarCardH data={item}/>
              </div>
            )) : (
              <div className="flex items-center justify-center h-40">
                <span className="text-neutral-500 dark:text-neutral-400 text-lg">
                  No results found
                </span>
              </div>
            )}
          </div>
          {/*<div className="flex mt-16 justify-center items-center">*/}
          {/*  <Pagination/>*/}
          {/*</div>*/}
        </div>

        <div
          className="flex xl:hidden items-center justify-center fixed bottom-8 left-1/2 transform -translate-x-1/2 px-6 py-2 bg-neutral-900 text-white shadow-2xl rounded-full z-30  space-x-3 text-sm cursor-pointer"
          onClick={() => setShowFullMapFixed(true)}
        >
          <i className="text-lg las la-map"></i>
          <span>Show map</span>
        </div>

        {/* MAPPPPP */}
        <div
          className={`xl:flex-grow xl:static xl:block ${
            showFullMapFixed ? "fixed inset-0 z-50" : "hidden"
          }`}
        >
          {showFullMapFixed && (
            <ButtonClose
              onClick={() => setShowFullMapFixed(false)}
              className="bg-white absolute z-50 left-3 top-3 shadow-lg rounded-xl w-10 h-10"
            />
          )}

          <div className="fixed xl:sticky top-0 xl:top-[88px] left-0 w-full h-full xl:h-[calc(100vh-88px)] rounded-md overflow-hidden">
            <MapContainer
              currentHoverID={currentHoverID}
              services={servicesPopulated}
              listingType="car"
              centerPosition={initialCenterSaved}
              userLocation={latitude && longitude ? { latitude, longitude } : undefined}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionGridHasMap;
